import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    uploadLabel: {
        paddingTop: 7
    },
    fileLink: {
        cursor: 'pointer'
    },
    table: {
        borderCollapse: 'collapse',
        marginBottom: 10
    },
    th: {
        border: '1px solid #333',
        padding: '4px 8px',
        fontWeight: 'bold'
    },
    td: {
        border: '1px solid #333',
        padding: '4px 8px'
    },
    uploadRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    uploadFull: {
        flex: 1
    },
    uploadShrink: {
        flex: '0 0 auto'
    },
    appendRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    }
};
